import React from "react";
import "./BlogCarousel.css";
import Marquee from "react-fast-marquee";
export default function BlogCarousel({ contributedBlogs }) {
  return (
    <div className="skills">
      <div className="skillsContainer">
        <div className="skill--scroll">
          <Marquee
            gradient={false}
            speed={80}
            pauseOnHover={false}
            pauseOnClick={true}
            delay={0}
            play={true}
            direction="left"
          >
            {contributedBlogs.map((blog) => (
              <div className="skill--box" key={blog.id}>
                <a href={blog.url} target="_blank" rel="noreferrer">
                  <img src={blog.image} alt={blog.name} />
                  <h3>{blog.name}</h3>
                </a>
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </div>
  );
}
